module.exports = __webpack_public_path__ + "static/media/jean.f18ec6dd.png";